import { Injectable } from '@angular/core';
import { PgSubscriptMessagesComponent } from '../pg-subscript-messages/pg-subscript-messages.component';
import { PgSubscriptStateCalculator } from '../pg-subscript-messages/pg-subscript-state-calculator';
import { PgFieldGridComponent } from './pg-field-grid.component';

@Injectable()
export class PgFieldGridSubscriptController {
  constructor(public pgSubscriptStateCalculator: PgSubscriptStateCalculator) {}

  checkSubscriptState(
    host: PgSubscriptMessagesComponent,
    grid: PgFieldGridComponent,
    animate: boolean = true
  ) {}
}
